export default "__VITE_ASSET__Bo0A$fYO__"